
define('text!modules/success/success_template.html',[],function () { return '<div class="success-modal-content">\r\n  <p><%- message %></p>\r\n  <div class="success-modal-buttons">\r\n    <button class="button button-primary js-success-ok">ok</button>\r\n  </div>\r\n</div>\r\n';});

